<script>
import macarons from "@/common/theme.json";
import cloneDeep from "lodash/cloneDeep";
import sortBy from "lodash/sortBy";
import moment from "moment";
const fiveList = [3, 3.5, 4, 4.5, 5, 5.3];

const twoList = [0.01, 0.03, 0.1, 0.3, 1.0, 2.0];
export default {
  props: {
    challengeResult: Array
  },
  data() {
    const copyResultData = cloneDeep(this.challengeResult);
    return {
      copyResultData,
      visionChallengeChart: {}
    };
  },
  mounted() {
    this.$nextTick(function() {
      this.drawLine();
    });
    window.addEventListener("resize", this.resize);
  },

  destroyed() {
    window.removeEventListener("resize", this.resize);
  },
  methods: {
    drawLine() {
      let reverseData = sortBy(this.copyResultData, "createdAt");
      let moreThanWeek = true;
      let weekCounts = 12;
      let intervaltest = undefined;
      if (reverseData.length < 2) {
        moreThanWeek = false;
      } else {
        const count = moment(
          reverseData[reverseData.length - 1].createdAt
        ).diff(reverseData[0].createdAt, "weeks");
        if (count < 1) {
          moreThanWeek = false;
        }
        if (count > 11) {
          weekCounts = 12;
        } else {
          weekCounts = count + 1;
          intervaltest = 7 * 3600000 * 24 + 1000;
        }
      }
      this.$echarts.registerTheme("myMacarons", macarons);
      const chartComponent = this.$refs.visionChallengeResult;
      let myChart = this.$echarts.init(chartComponent, "myMacarons");
      let getX = [];
      let firstDay = moment(reverseData[0].createdAt);
      getX = reverseData.map((o, index) =>
        moment(o.createdAt)
          // .add(index + 1, "weeks")
          .format("YYYY-MM-DD HH:mm:ss")
      );
      const getLeft = reverseData.map((o, index) => [
        moment(o.createdAt)
          // .add(index + 1, "weeks")
          .format("YYYY-MM-DD HH:mm:ss"),
        o.leftEyeVision
      ]);
      const getRight = reverseData.map((o, index) => [
        moment(o.createdAt)
          // .add(index + 1, "weeks")
          .format("YYYY-MM-DD HH:mm:ss"),
        o.rightEyeVision
      ]);
      // console.log(getX, getLeft, getRight);

      myChart.setOption({
        title: {
          text: "视力成长曲线",
          textStyle: {
            color: "#212223"
          }
        },
        tooltip: {
          trigger: "axis",
          formatter: params => {
            var result = `${params[0].data[0]} <br/>`;
            params.map(item => {
              result += `${item.seriesName} : ${
                isNaN(item.value[1]) ? "-" : item.value[1]
              } </br>`;
            });
            return result;
          }
        },
        legend: {
          data: ["右眼", "左眼"],
          show: true,
          icon: "line",
          left: "center"
        },
        grid: {
          left: "3%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [
          {
            type: "time",
            splitLine: { show: false },
            axisLabel: {
              formatter: function(item, index) {
                const weekNumber = moment(item).diff(firstDay, "weeks");
                if (!moreThanWeek) {
                  return moment(item).format("MM-DD HH:mm");
                } else {
                  if (index === 0) {
                    return `第1周`;
                  } else {
                    return `第${weekNumber + 1}周`;
                  }
                }
              }
            },
            minInterval: 7 * 3600 * 24 * 1000 + 1000,
            interval: intervaltest || undefined,
            splitNumber: weekCounts,
            boundaryGap: false,
            data: getX.map(function(item) {
              return item;
            })
          }
        ],
        yAxis: {
          min: 3.0,
          max: 5.3,
          splitLine: {
            show: true,
            lineStyle: {
              type: "dotted",
              color: "rgba(155, 155, 155, 0.5)"
            }
          },
          axisLabel: {
            formatter: function(value) {
              const getIndex = fiveList.indexOf(value);
              const result = `${value.toFixed(1)}（${twoList[getIndex].toFixed(
                2
              )}）`;
              let texts = [];
              texts.push(result);
              return texts;
            }
          },
          axisLine: {
            show: false
          },
          type: "value"
        },
        series: [
          {
            name: "右眼",
            type: "line",
            data: getRight,
            itemStyle: {
              normal: {
                color: "#2FC25B",
                lineStyle: {
                  color: "#2FC25B"
                }
              }
            }
          },
          {
            name: "左眼",
            type: "line",
            data: getLeft,
            itemStyle: {
              normal: {
                color: "#1890FF",
                lineStyle: {
                  color: "#1890FF"
                }
              }
            }
          }
        ]
      });
      this.visionChallengeChart = myChart;
    },
    resize: function() {
      this.visionChallengeChart.resize();
    }
  }
};
</script>
<template>
  <div ref="visionChallengeResult" :style="{width: '95%', height: '450px'}"></div>
</template>


// WEBPACK FOOTER //
// src/components/patientManagement/visionChallengeChart.vue